<div class="pfb-wrap">
  <div class="pfb-header">
    <h2 class="pfb-title">{{ 'feedback' | translate }}</h2>
    <div class="pfb-header-actions">
      <button type="button" class="pfb-refresh-btn" [disabled]="loading" (click)="refresh()">
        <i class="ri-refresh-line"></i>
      </button>
      <button type="button" class="pfb-add-btn" (click)="openSubmitModal()">
        {{ 'addFeedback' | translate }}
      </button>
    </div>
  </div>

  <div class="pfb-error" *ngIf="error">{{ error }}</div>

  <div class="pfb-list" *ngIf="!loading; else pfbLoading">
    <div class="pfb-empty" *ngIf="!items.length && !error">
      <div class="pe-icon"><i class="ph ph-folder-open"></i></div>
      <div class="pe-title">{{ 'dataNotFound' | translate }}</div>
    </div>

    <div class="pfb-card" *ngFor="let item of items; trackBy: trackByFeedbackId">
      <div class="pfb-card-accent"></div>
      <div class="pfb-card-body">
        <div class="pfb-card-top" (click)="toggleExpand(item)">
          <div class="pfb-card-top-main">
            <div class="pfb-card-date">{{ item.createdAt | date: 'dd MMM y, hh:mm a' }}</div>
            <span class="pfb-attachment-badge" *ngIf="item.attachments?.length">
              <i class="ri-attachment-2"></i> {{ item.attachments.length }}
            </span>
          </div>
          <i class="pfb-caret" [class.ri-arrow-down-s-line]="!isExpanded(item)" [class.ri-arrow-up-s-line]="isExpanded(item)"></i>
        </div>

        <div class="pfb-card-preview" *ngIf="!isExpanded(item)" (click)="toggleExpand(item)">{{ item.message }}</div>

        <ng-container *ngIf="isExpanded(item)">
          <div class="pfb-card-message">{{ item.message }}</div>

          <div class="pfb-attachments-strip" *ngIf="item.attachments?.length">
            <div class="pfb-attachment-thumb" *ngFor="let att of item.attachments" (click)="openAttachment(att)">
              <img *ngIf="isImageAttachment(att)" [src]="att.fileUrl" alt="{{ att.fileName }}" />
              <div class="pfb-video-thumb" *ngIf="!isImageAttachment(att)">
                <i class="ri-play-circle-fill"></i>
              </div>
            </div>
          </div>

          <div class="pfb-response" [class.pfb-response-empty]="!item.systemResponse">
            <ng-container *ngIf="item.systemResponse; else pfbNoResponse">
              <div class="pfb-response-header">
                <i class="ri-checkbox-circle-fill pfb-response-check"></i>
                <span class="pfb-response-title">{{ 'schoolResponse' | translate }}</span>
                <span class="pfb-response-date">{{ item.updatedAt | date: 'dd MMM y, hh:mm a' }}</span>
              </div>
              <div class="pfb-response-text">{{ item.systemResponse }}</div>
            </ng-container>
            <ng-template #pfbNoResponse>
              <div class="pfb-response-none">{{ 'noResponseYet' | translate }}</div>
            </ng-template>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <ng-template #pfbLoading>
    <div class="pfb-list">
      <div class="pfb-card pfb-card-skeleton" *ngFor="let n of [1,2,3,4,5,6,7,8]"></div>
    </div>
  </ng-template>

  <div class="pfb-pagination" *ngIf="!loading && items.length && maxPageNumber > 1">
    <button type="button" class="pfb-page-btn" [disabled]="currentPage <= 1" (click)="goToPrevPage()">
      <i class="ri-arrow-left-s-line"></i> {{ 'previous' | translate }}
    </button>
    <span class="pfb-page-indicator">{{ currentPage }} / {{ maxPageNumber }}</span>
    <button type="button" class="pfb-page-btn" [disabled]="currentPage >= maxPageNumber" (click)="goToNextPage()">
      {{ 'next' | translate }} <i class="ri-arrow-right-s-line"></i>
    </button>
  </div>
</div>

<!-- Submit modal — centered overlay, structured like parent-notifications'
     pn-confirm-overlay/pn-confirm-box but sized for a form. -->
<div class="pfb-modal-overlay" *ngIf="showSubmitModal" (click)="closeSubmitModal()">
  <div class="pfb-modal-box" (click)="$event.stopPropagation()">
    <div class="pfb-modal-header">
      <h3 class="pfb-modal-title">{{ 'addFeedback' | translate }}</h3>
      <button type="button" class="pfb-modal-close" (click)="closeSubmitModal()"><i class="ri-close-line"></i></button>
    </div>

    <div class="pfb-modal-body">
      <div class="pfb-modal-error" *ngIf="submitError">{{ submitError }}</div>

      <textarea class="pfb-textarea" rows="5" [(ngModel)]="message"
        placeholder="{{ 'writeYourFeedbackPlaceholder' | translate }}"></textarea>

      <label class="pfb-dropzone" [class.pfb-dropzone-active]="isDraggingOverAttach"
        (dragover)="onAttachDragOver($event)" (dragleave)="onAttachDragLeave($event)" (drop)="onAttachmentDropped($event)">
        <input type="file" accept="image/*,video/*" multiple hidden (change)="onAttachmentSelected($event)" />
        <div class="pfb-dropzone-icon"><i class="ri-upload-cloud-2-line"></i></div>
        <div class="pfb-dropzone-text"><strong>{{ 'attachMedia' | translate }}</strong> {{ 'orDragAndDrop' | translate }}</div>
        <div class="pfb-dropzone-hint">{{ attachmentCountLabel }}</div>
      </label>

      <div class="pfb-attach-strip" *ngIf="attachments.length">
        <div class="pfb-attach-thumb" *ngFor="let a of attachments; let i = index">
          <img *ngIf="a.isImage && a.objectUrl" [src]="a.objectUrl" alt="" />
          <div class="pfb-video-thumb" *ngIf="!a.isImage">
            <i class="ri-video-line"></i>
          </div>
          <button type="button" class="pfb-attach-remove" (click)="removeAttachment(i)">
            <i class="ri-close-line"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="pfb-modal-footer">
      <button type="button" class="pfb-cancel-btn" [disabled]="submitting" (click)="closeSubmitModal()">{{ 'cancel' | translate }}</button>
      <button type="button" class="pfb-submit-btn" [disabled]="submitting || !message.trim()" (click)="submitFeedback()">
        <span *ngIf="!submitting">{{ 'submitFeedback' | translate }}</span>
        <span *ngIf="submitting" class="pfb-submit-spinner-row">
          <i class="ri-loader-4-line pfb-spin"></i> {{ 'submittingEllipsis' | translate }}
        </span>
      </button>
    </div>
  </div>
</div>

<!-- Attachment image viewer — same small-centered-overlay pattern as
     parent-broadcast's own image viewer. -->
<div class="pfb-viewer-overlay" *ngIf="imageViewerUrl" (click)="closeImageViewer()">
  <div class="pfb-image-viewer-window" (click)="$event.stopPropagation()">
    <button type="button" class="pfb-viewer-close" (click)="closeImageViewer()"><i class="ri-close-line"></i></button>
    <img [src]="imageViewerUrl" class="pfb-image-viewer-img" alt="" />
  </div>
</div>

<!-- Attachment video viewer — same overlay pattern, swapping the image for
     a native <video controls> element. -->
<div class="pfb-viewer-overlay" *ngIf="videoViewerUrl" (click)="closeVideoViewer()">
  <div class="pfb-video-viewer-window" (click)="$event.stopPropagation()">
    <button type="button" class="pfb-viewer-close" (click)="closeVideoViewer()"><i class="ri-close-line"></i></button>
    <video [src]="videoViewerUrl" class="pfb-video-viewer-video" controls autoplay></video>
  </div>
</div>
